export default "__VITE_ASSET__BV3TttRY__"